<template>
  <div>
    <SwitchCheckbox
      :onClick="jobSaved"
      v-model="bigfive"
      :value="bigfive"
      label="SOLICITAR PREENCHIMENTO DO ASSESSMENT BIGFIVE"
    />
    <div v-if="bigfive">
      <div class="row mt-2">
        <div class="col-lg-8 col-xs-12">
          <div class="ml-4">
            <span>Em qual etapa deseja que o teste seja feito: </span>
            <select
              v-model="selective_process_id"
              class="form-control"
              @change="saveBigfive(amount_itens)"
            >
              <option
                v-for="selective_process in selective_processes"
                :key="selective_process.id"
                :value="selective_process.id"
              >
                {{ selective_process.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="ml-4 mt-3">
        <label class="d-block">
          <input
            type="radio"
            v-model="amount_itens"
            @click="saveBigfive(120)"
            :value="120"
          />
          Completo (Aproximadamente 12min)
        </label>
        <label class="d-block">
          <input
            type="radio"
            @click="saveBigfive(50)"
            v-model="amount_itens"
            :value="50"
          />
          Simplificado (Aproximadamente 6min)
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchCheckbox from "./SwitchCheckbox.vue";

export default {
  props: ["jobs", "job_id", "amount", "selective_process"],
  components: { SwitchCheckbox },
  data: () => ({
    bigfive: false,
    amount_itens: 0,
    selective_processes: [],
    selective_process_id: 0,
  }),
  mounted() {
    this.$root.$on("columnsChanged", (selective_processes) => {
      this.selective_processes = selective_processes;
      if (this.selective_process_id === 0) {
        this.selective_process_id = selective_processes.filter(
          (process) => process.status === 1
        )[0].id;
      }
    });
  },
  watch: {
    bigfive() {
      eventBus.$emit("setBigfive", this.bigfive);
    },
    jobsBigfive() {
      if (this.jobs.bigfive) {
        this.bigfive = this.jobs.bigfive;
        if (this.selective_process)
          this.selective_process_id = this.selective_process;
        if (this.amount) this.amount_itens = this.amount;
      }
    },
  },
  computed: {
    jobsBigfive() {
      return this.jobs.bigfive;
    },
  },
  methods: {
    jobSaved(event) {
      if (this.job_id === 0) {
        this.$toast.error(
          "POR FAVOR, PREENCHA O TÍTULO E DESCRIÇÃO DA VAGA PARA CONTINUAR"
        );
        event.preventDefault();
      }
    },
    saveBigfive(amount) {
      if (amount === 0) amount = 50;

      if (this.jobs.bigfive_id == 0) {
        axios
          .post("/recruiters/assessments/bigfives", {
            bigfive: {
              name: this.jobs.name,
              status: 1,
              amount_itens: amount,
              selective_process_id: this.selective_process_id,
            },
          })
          .then((response) => {
            eventBus.$emit("setBigfiveId", {
              bigfive_id: response.data.id,
              amount_itens: response.data.amount_itens,
            });
            eventBus.$emit("saveJob");
          });
      } else {
        axios
          .put("/recruiters/assessments/bigfives/" + this.jobs.bigfive_id, {
            bigfive: {
              amount_itens: amount,
              selective_process_id: this.selective_process_id,
            },
          })
          .then((response) => {
            eventBus.$emit("setBigfiveId", {
              bigfive_id: response.data.id,
              amount_itens: response.data.amount_itens,
            });
          });
      }
    },
  },
};
</script>